import { Parent } from "../../../../models/parent";
import { Student } from "../../../../models/student";
import { BankAccountInfo } from "./bank-account-info";
import { StudentAdditionalInfo } from "./student-additional-info";

export class StudentProfileInfo {
    public student_info: Student;
    public parents_info: Array<Parent>;
    public bank_account_info: BankAccountInfo;
    public student_additional_info: StudentAdditionalInfo;
}